import {
  FOURNISSEURS_FETCH,
  FOURNISSEURS_UPDATE
} from '../constants/ActionTypes';
import DbWsAction from './models/DbWsAction';

const action = new DbWsAction(
  FOURNISSEURS_FETCH,
  FOURNISSEURS_UPDATE
);

export const fetch = action.fetch;
export const update = action.update;
